module.exports = "<app-topmenu></app-topmenu>\n<router-outlet></router-outlet>\n<app-message-snack></app-message-snack>\n<div id=\"blockContent\" [class.visible]=\"blockInteraction\" (click)=\"$event.preventDefault();\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main